export enum Action {
    INIT = 'Init',
    ADD = 'Add',
    DELETE = 'Delete',
    ICONIC = 'Iconic'
}